"use strict";

import Common from "./../core/Common";

/**
 * Generic Preloader for prototyping
 * @class
 */
export default class GenericPreloaderScene extends P3.Scene {
    constructor() {
        super();

        this.loaded = 0;
        this._bar = null;
        this._barWidth = 925;

    }

    init() {
        super.init();

       // this._bg = P3.utils.sprite(P3.assets.texture("preloader"), this, new PIXI.Point(0.5, 0.5));
        //this._bg.width = Common.STAGE_WIDTH;
        //this._bg.height = Common.STAGE_HEIGHT;
       // this._bg.x = Common.STAGE_WIDTH * 0.5;
       // this._bg.y = Common.STAGE_HEIGHT * 0.5;
        //this._bg.scale.set(2);

        this._bar = P3.utils.sprite(P3.assets.texture("preloader_bar"), this);
        this._bar.position.set(Common.STAGE_WIDTH * 0.5 - 465, P3.View.height - 195);
        this._bar.width = 0;
        //this._bar.height = 8;
        this._bar.anchor = new PIXI.Point(0, 0.5);
        this._bar.tint = 0xd3d3d3;
        this._bar.y += 45;

        const txt = createText("foo", {size: 1});
        txt.x = Common.STAGE_WIDTH;//put it off screen
        this.addChild(txt);

        const txt2 = createText("foo", {size: 1}, "thin");
        txt2.x = Common.STAGE_WIDTH;//put it off screen
        this.addChild(txt2);

        //this.addChild(this._bar);
    }

    destroy() {
        super.destroy({children: true});
    }

    appear() {
        super.appear();
    }

    resize() {
        this.x = (P3.View.width - Common.STAGE_WIDTH) * 0.5;
    }

    update() {
        const loaded = Math.min(1, this.loaded);
        this._bar.width = loaded * this._barWidth;
    }

    onLoadComplete() {
        delay(() => this.end(), 0.2);
    }

    end() {
        this.signals.next.dispatch(this);
    }
}
